import styled from "styled-components";


export const ModalWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(28, 38, 52, 0.55);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  font-family: 'Poppins', sans-serif;

  .modal-box {
    background-color: #fff;
    padding: 32px 28px 26px;
    border-radius: 18px;
    max-width: 420px;
    width: 90%;
    text-align: center;
    box-shadow: 0 24px 60px rgba(28, 38, 52, 0.30);
    border: 1px solid #e8eee5;
    position: relative;
    overflow: hidden;

    &::before {
      content: '';
      position: absolute;
      top: 0; left: 0; right: 0;
      height: 4px;
      background: linear-gradient(90deg, #509540, #6dd05a);
    }

    h2 {
      font-size: 18px;
      color: #1C2634;
      font-weight: 700;
      line-height: 1.5;
      margin: 0;
    }
  }

  .modal-buttons {
    display: flex;
    justify-content: center;
    gap: 12px;
    margin-top: 24px;

    button {
      min-width: 130px;
      padding: 12px 28px;
      font-size: 14px;
      font-weight: 700;
      cursor: pointer;
      border: none;
      border-radius: 10px;
      background: linear-gradient(135deg, #509540, #3d7a30);
      color: #fff;
      box-shadow: 0 6px 16px rgba(80, 149, 64, 0.30);
      transition: all 0.2s;
      font-family: 'Poppins', sans-serif;

      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 10px 22px rgba(80, 149, 64, 0.40);
      }
    }
  }
`;